import merge from '@core/lodash/merge'
import { pruneNilValues } from '@core/object'
import { getSession } from '@core/tracking/session'
import type { ISendPixelTracking } from '@core/tracking/types'

import { getGlobalTrackingFields } from './helpers/globalTrackingFields'
import { prepareGuestFields } from './helpers/prepareGuestFields'
import { prepareSessionFields } from './helpers/prepareSessionFields'
import { sendPixelTracking } from './sendPixelTracking'

/**
 * Sends a pixel tracking event to the backend. It will attach the session data
 * and the client metadata to the payload.
 */
export async function sendPixelTrackingWithSession({
  endpoint,
  data = {},
  host,
}: ISendPixelTracking): Promise<Response | boolean | void> {
  const session = getSession()
  if (!session) {
    return
  }

  const pixelTrackingFields = {
    ...getGlobalTrackingFields(),
    // Removing event_properties from the payload to avoid duplication, since sendPixelTracking already adds it
    //event_properties: getGlobalEventProperties(),
  }

  const mergedData = pruneNilValues(
    merge(
      {},
      pixelTrackingFields,
      prepareSessionFields(session),
      prepareGuestFields(),
      data,
    ),
  )

  return sendPixelTracking({ endpoint, data: mergedData, host })
}
